import React, { useState } from 'react'

import * as service from 'service'
import DataProcessOptionsContext from 'contexts/DataProcessOptionsContext'

const DataProcessOptionsProvider = ({ children }) => {
  const [data, setData] = useState(null)
  const [dataProcesses, setDataProcesses] = useState([])
  const [reload, setReload] = useState(false)
  const [sourceOptions, setSourceOptions] = useState([])
  const [dataProcessTemplate, setDataProcessTemplate] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const loadData = async () => {
    setIsLoading(true)
    const [responseOptions, responseDataProcessTemplate] = await Promise.all([
      service.dponet.dataProcesses.getRelationOptions({
        companyId: service.dponet.auth.getCompany(),
      }),
      service.dponet.dataProcessTemplates.get(),
    ])

    setData(responseOptions.data)
    setDataProcessTemplate(
      responseDataProcessTemplate?.data?.dataProcessTemplate,
    )
    setIsLoading(false)
  }

  return (
    <DataProcessOptionsContext.Provider
      value={{
        data,
        dataProcesses,
        dataProcessTemplate,
        isLoading,
        loadData,
        reload,
        setDataProcesses,
        setReload,
        setSourceOptions,
        sourceOptions,
      }}
    >
      {children}
    </DataProcessOptionsContext.Provider>
  )
}

export default DataProcessOptionsProvider
